import React, { useEffect, useState } from 'react'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import * as FileSaver from 'file-saver'
import moment from 'moment/moment'
import useToast from '../hooks/useToast'
import { Calendar } from 'primereact/calendar'
import { leaveDayPeriod } from 'utils/Constants'

const LeaveMovementsReport = () => {
  const [getReport, loading] = useRequest()
  const [request] = useRequest()
  const { showToast } = useToast()
  const [report, setReport] = useState([])
  const [companies, setCompanies] = useState([])
  const [leaveTypes, setLeaveTypes] = useState([])
  const [requestBody, setRequestBody] = useState({
    startDate: moment().subtract(1, 'months').toISOString(),
    endDate: moment().toISOString(),
    companyId: null,
    leaveTypeIds: [],
  })

  useEffect(() => {
    request('/Developer/GetCompanies', {
      method: 'GET',
    }).then((res) => {
      if (res.data.ok) {
        setCompanies(res.data.result.map((s) => ({ label: s.name, value: s.id })))
      }
    })

    request('/LeaveType/GetAllLeaveTypes', {
      method: 'GET',
    }).then(res => {
      setLeaveTypes(res?.data?.result?.reverse()?.map(t => ({
        label: t.name,
        value: t.id,
      })))
    })

    handleSubmit()
  }, [])

  const handleSubmit = () => {
    if (!requestBody.endDate || !requestBody.startDate) {
      showToast('Lütfen Başlangıç Tarihi ve Bitiş Tarihi Alanlarını Doldurun', 'error')
    } else {
      getReport('/DeveloperLeave/MovementReport', { method: 'POST', data: requestBody }).then((res) => {
        if (res.data.ok) {
          setReport(res.data.result)
        }
      })
    }
  }

  const handleChange = (e) => {
    setRequestBody((prev) => ({ ...prev, [e.name]: e.value }))
  }

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const newArray = report.map((item) => {
        const rest = {
          'Kişi Adı': item.forWhomUser?.fullName,
          'İzin Türü': item.leaveType?.name || 'Genel',
          'İzin Başlangıç Tarihi': item.startDate && moment(item.startDate).format('LL'),
          'İzin Bitiş Tarihi': item.endDate && moment(item.endDate).format('LL'),
          'Yarım Gün': (item.startDate === item.endDate
              ? (item.startDayPeriod !== leaveDayPeriod[0].value)
              : (item.startDayPeriod !== leaveDayPeriod[0].value
                  || item.endDayPeriod !== leaveDayPeriod[0].value))
              ? 'Evet'
              : 'Hayır',
          Şirket: item.forWhomUser?.company?.name,
        }
        return rest
      })
      const workSheet = xlsx.utils.json_to_sheet(newArray)
      const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workBook, {
        bookType: 'xlsx',
        type: 'array',
      })
      saveAsExcelFile(excelBuffer, 'izin-hareket-raporu')
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    let EXCEL_EXTENSION = '.xlsx'
    const data = new Blob([buffer], {
      type: EXCEL_TYPE,
    })
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
  }

  return (
    <AnimatedSpan className="page-container d-flex flex-column gap-4">
      <div className="row-margin-x">
        <div className="col-md-12">
          <DataTable
            stripedRows
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
            emptyMessage="Hiç Kayıt Bulunamadı"
            rows={25}
            className="p-1"
            paginatorLeft={<Button type="button" className="p-button-text" />}
            paginatorRight={<Button type="button" className="p-button-text" />}
            value={report}
            dataKey="id"
            loading={loading}
            header={() => (
              <div className="d-flex justify-content-between">
                <div className="row flex-1">
                  <div className="col-md-3">
                    <div className="d-flex gap-2">
                      <Calendar
                        className={'w-100'}
                        dateFormat="dd/mm/yy"
                        placeholder="Başlangıç Tarihi"
                        value={requestBody.startDate && new Date(requestBody.startDate)}
                        name="startDate"
                        onChange={(e) => {
                          handleChange({
                            name: e.target.name,
                            value: moment(e.target.value).add(3, 'hours').toISOString(),
                          })
                        }}
                      />
                      <Calendar
                        className={'w-100'}
                        dateFormat="dd/mm/yy"
                        placeholder="Bitiş Tarihi"
                        value={requestBody.endDate && new Date(requestBody.endDate)}
                        name="endDate"
                        onChange={(e) => {
                          handleChange({
                            name: e.target.name,
                            value: moment(e.target.value).add(3, 'hours').toISOString(),
                          })
                        }}
                      />

                    </div>
                  </div>
                  <div className="col-md-3">
                    <DefaultSelect
                      isClearable
                      isSearchable
                      placeholder="Şirket"
                      value={
                        companies?.find((p) => p.value == requestBody.companyId) &&
                        companies?.find((p) => p.value == requestBody.companyId)
                      }
                      selectOptions={companies}
                      handleChange={(e) => handleChange({ name: 'companyId', value: e?.value ? e.value : null })}
                    />
                  </div>
                  <div className="col-md-3">
                    <DefaultSelect
                      isClearable
                      isMulti
                      placeholder={'İzin Türü'}
                      value={requestBody.leaveTypeIds?.map((c) => leaveTypes.find((l) => l.value == c))}
                      selectOptions={leaveTypes}
                      handleChange={(e) => handleChange({ name: 'leaveTypeIds', value: e?.map(c => c.value) || [] })}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex align-items-center gap-2">
                      <Button
                        disabled={loading}
                        title="Raporu Al"
                        handleClick={handleSubmit}
                        className="btn-primary w-100 d-flex justify-content-center"
                      />
                      <Button
                        disabled={loading}
                        title="Excel"
                        handleClick={exportExcel}
                        className="btn-success w-100 d-flex justify-content-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          >
            <Column
              sortable
              className="text-semi-bold text-bold "
              headerClassName="text-bold bg-primary text-default"
              field="fullName"
              style={{ width: 'auto' }}
              header="Kişi Adı"
              body={(rowData) => {
                return rowData.forWhomUser?.fullName
              }}
            />
            <Column
              headerClassName="text-bold bg-primary text-default"
              className="text-semi-bold text-sm"
              field="leaveType"
              header="İzin Türü"
              style={{ width: 'auto' }}
              body={(rowData) => {
                return rowData.leaveType?.name || 'Genel'
              }}
            />
            <Column
              sortable
              className="text-semi-bold text-sm"
              headerClassName="text-bold bg-primary text-default"
              field="startDate"
              header="İzin Başlangıç Tarihi"
              body={(rowData) => {
                return rowData.startDate && <span> {moment(rowData.startDate).format('LL')}</span>
              }}
            />
            <Column
              sortable
              className="text-semi-bold text-sm"
              headerClassName="text-bold bg-primary text-default"
              field="endDate"
              header="İzin Bitiş Tarihi"
              body={(rowData) => {
                return rowData.endDate && <span> {moment(rowData.endDate).format('LL')}</span>
              }}
            />
            <Column
                className="text-semi-bold text-sm"
                headerClassName="text-bold bg-primary text-default"
                header="Yarım Gün"
                body={(rowData) => {
                  let isHalfDay = rowData.startDate === rowData.endDate
                      ? (rowData.startDayPeriod !== leaveDayPeriod[0].value)
                      : (rowData.startDayPeriod !== leaveDayPeriod[0].value || rowData.endDayPeriod !== leaveDayPeriod[0].value)
                  return isHalfDay ? 'Evet' : 'Hayır'
                }}
            />
            <Column
              sortable
              className="text-semi-bold text-sm"
              headerClassName="text-bold bg-primary text-default"
              field="company"
              header="Şirket"
              body={(rowData) => {
                return rowData.forWhomUser?.company?.name
              }}
            />
          </DataTable>
        </div>
      </div>
    </AnimatedSpan>
  )
}

export default LeaveMovementsReport
